import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import Swal from "sweetalert2";
import DeparturesForm from "./despartures-form";
import "./departures.css";
import axios from "axios";

function Departures() {
  const [masterValue, setMasterValue] = useState("");
  const [masterData, setMasterData] = useState(null);
  const [view, setView] = useState("input");
  const [error, setError] = useState("");
  const [flight, setFlight] = useState("");
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [flightData, setFlightData] = useState(null);
  const formattedFlight = flight.replace("/", "_");

  const simulatedFlights = [
    {
      flight: "AM0123/25MAY",
      year: "2025",
      cargo: [
        { awb: "139-46289876", piezas: 3, peso: 37.8 },
        { awb: "139-46219855", piezas: 16, peso: 459 },
      ],
    },
    {
      flight: "AM0456/13APR",
      year: "2025",
      cargo: [],
    },
    {
      flight: "AM0089/09JUN",
      year: "2024",
      cargo: [{ awb: "139-88888888", piezas: 5, peso: 220 }],
    },
  ];

  const formatFlight = (value) => {
    const regex = /^([A-Z]{2})(\d{1,4})\/(\d{2})([A-Z]{3})$/i;
    const match = value.toUpperCase().match(regex);

    if (!match) return value.toUpperCase(); // si no matchea, solo convierte a mayúsculas

    const [, airline, number, day, month] = match;
    const paddedNumber = number.padStart(4, "0");
    return `${airline}${paddedNumber}/${day}${month.toUpperCase()}`;
  };

  const handleInputChange = (e) => {
    const input = e.target.value;
    const formatted = formatFlight(input);
    setFlight(formatted);

    if (error) setError("");
  };

  const generateYears = () => {
    const startYear = 2019;
    const currentYear = new Date().getFullYear();
    const nextYear = currentYear + 1;
    const years = [];

    for (let y = startYear; y <= nextYear; y++) {
      years.push(y.toString());
    }

    return years;
  };

  const handleYearChange = (e) => {
    setYear(e.target.value);
  };

  const handleSearch = async () => {
    if (!flight.trim()) {
      setError("Este campo es obligatorio");
      return;
    }

    try {
      Swal.fire({
        title: "Consultando vuelo...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const encodedFlight = encodeURIComponent(flight);

      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/expo_departures/open_flight`,
        {
          params: {
            flight: formattedFlight,
            year: year, 
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      Swal.close();

      const data = response.data;
      const cargo = data?.cargo || [];

      // 👉 SIN CARGA
      if (cargo.length === 0) {
        Swal.fire({
          html: `
                    <div style="background:#020C41;color:white;padding:10px;font-weight:bold">
                        Carga actual del vuelo ${flight}
                    </div>
                    <div class="alert alert-danger mt-3 text-start">
                        No hay carga en este vuelo
                    </div>
                `,
          showCancelButton: true,
          confirmButtonText: "Continuar",
          cancelButtonText: "Cerrar",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            setView("departuresForm");
            setFlightData({ flight, year });
          }
        });
      } else {
        const rows = cargo
          .map(
            (row) => `
                <tr>
                    <td>${row.awb}</td>
                    <td>${row.piezas}</td>
                    <td>${row.peso}</td>
                </tr>
            `
          )
          .join("");

        Swal.fire({
          width: 650,
          html: `
                    <div style="background:#020C41;color:white;padding:10px;font-weight:bold">
                        Carga actual del vuelo ${flight}
                    </div>
                    <table class="table table-striped mt-3">
                        <thead>
                            <tr>
                                <th>AWB</th>
                                <th>Piezas</th>
                                <th>Peso</th>
                            </tr>
                        </thead>
                        <tbody>${rows}</tbody>
                    </table>
                `,
          showCancelButton: true,
          confirmButtonText: "Continuar",
          cancelButtonText: "Cerrar",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            setView("departuresForm");
            setFlightData({ flight, year });
          }
        });
      }
    } catch (error) {
      Swal.close();
      console.error("Error de conexión:", error);

      Swal.fire({
        icon: "error",
        title: "Error de conexión",
        text:
          error.response?.data?.message ||
          "No se pudo obtener la información del vuelo",
        confirmButtonColor: "#020C41",
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>Horus | Salidas</title>
      </Helmet>
      <ScrollToTop />
      <div className="container-fluid">
        {view === "input" && (
          <div className="row justify-content-center">
            <div className="col-3">
              <label for="inputMaster" class="amc-label">
                Vuelo
              </label>
              <input
                type="text"
                class="form-control"
                id="name_flight"
                value={flight}
                onChange={handleInputChange}
              />
              {error && <small className="text-danger">{error}</small>}
            </div>
            <div className="col-3">
              <label for="inputSelect" class="amc-label">
                Año
              </label>
              <select
                className="form-select"
                name="year"
                id="year"
                value={year}
                onChange={handleYearChange}
              >
                {generateYears().map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>

              <div className="btns mt-3 d-flex justify-content-end gap-3">
                <button className="btnn" onClick={handleSearch}>
                  Buscar
                </button>
              </div>
            </div>
          </div>
        )}

        {view === "departuresForm" && (
          <DeparturesForm flightData={flightData} />
        )}
        {/* {view === 'form' && <CaptureForm masterNumber={masterValue} />} */}
      </div>
    </>
  );
}

export default Departures;
